/* eslint-disable no-console,no-template-curly-in-string */
import dotenv from "dotenv";

dotenv.config();

export default class Configuration {

	static betaTesters = [
		"906892",
		"349500",
		"349500-JS",
		"349500-JA",
		"349500-RA",
		"349500-dak",
	];

	static isUnlockedForBetaFeature(dealerId) {
		return this.betaTesters.includes(dealerId) || this.betaTesters.length === 0;
	}

	static get CONFIG () {
		return {
			mandator: "$REACT_APP_MANDATOR",
			academyUrl: "$REACT_APP_ACADEMY_URL",
			authServer: "$REACT_APP_AUTH_SERVER",
			dmsBaseUrl: "$REACT_APP_DMS_BASE_URL",
			apiBaseUrl: "$REACT_APP_API_BASE_URL",
			productBaseUrl: "$REACT_APP_PRODUCT_BASE_URL",
			trackingId: "$REACT_APP_TRACKING_ID",
			tireShopUrl: "$REACT_APP_TIRE_SHOP_URL",
			partShopUrl: "$REACT_APP_PART_SHOP_URL",
			partShopRegistrationUrl: "$REACT_APP_PART_SHOP_REGISTRATION_URL",
			specialPromotionId: "$REACT_APP_SPECIAL_PROMOTION_ID",
		};
	}

	static value (name) {
		if (!(name in this.CONFIG)) {
			console.log(`Configuration: There is no key named "${name}"`);
			return;
		}

		const value = this.CONFIG[name];

		if (!value) {
			console.log(`Configuration: Value for "${name}" is not defined`);
			return;
		}

		if (value.startsWith("$REACT_APP_")) {
			// value was not replaced, it seems we are in development.
			// Remove $ and get current value from process.env
			const envName = value.substr(1);
			const envValue = process.env[envName];
			if (envValue) {
				return envValue;
			} else {
				console.log(`Configuration: Environment variable "${envName}" is not defined`);
			}
		} else {
			// value was already replaced, it seems we are in production.
			return value;
		}
	}
}
